const newsletter = `
# eBL Newsletter 13

## 21 June 2023

### Fragmentarium & Bibliography

- Records for the tablets in the _Frau Professor Hilprecht Collection of Babylonian
  Antiquities_ have been created in the Fragmentarium. A systematic bibliography
  for these tablets has been compiled and imported, as are links to the 3D images
  of these tablets. The photography project of the Jena tablets, a collaboration
  between LMU Munich and FSU Jena, has been started; around 300 tablets have so
  far been photographed. See, e.g.,
  [HS.245](https://www.ebl.lmu.de/fragmentarium/HS.245).
- Records for the tablets in the _Vorderasiatisches Museum_ have been created in
  the Fragmentarium. Publication data has already been imported from the series
  publications KAJ, KAL, KAM, KAR, LKA, LKU, MARV, SBH, VS; others will follow.
- Photos of the SpTU tablets have been imported. They are visible to registered
  users with CAIC permissions.
- Editor: ø is now allowed. Shortcut: Ctrl + o
- Bibliography: O. Pedersén's _Archives and Libraries in the City of Assur_ (1986)
  has been systematically imported.
- There is a new Reference type: ARCHAEOLOGY. This should be used for literature
  on an artefact's excavation context.
- It is possible now to include and to search for monographs belonging to two
  different series, e.g. VS 19 = MARV 1.
- It is possible now to search by Period and Genre.

### Dictionary

- The published volumes of the _Supplement to the Akkadian Dictionaries_ (SAD) have
  been imported into the dictionary.`

export default newsletter
